import React, { useEffect, useState } from 'react'
import { Table,  Button } from 'reactstrap'
import {
	getActivityListLevelCount,
	getActivityListGradeLevelCount,
	getActivityListPositionCount,
	getActivityListWeeksPerYearCount,
	getActivityListCategoryCount,
	getOverviewTexts,
	saveOverviewTexts
} from '../../lib/studentactivityreport'
import { ToastNotification } from '../Lessons/CourseReport/CourseReportComponents'

const RecognitionTable = ({ recognition, overview, onOverviewChange }) => (
	<>
		<h5 className="mb-3">RECOGNITION</h5>
		<Table bordered className="text-center">
			<colgroup>
				<col style={{ width: '30%' }} />
				<col style={{ width: '20%' }} />
				<col style={{ width: '50%' }} />
			</colgroup>
			<thead>
				<tr>
					<th>Level</th>
					<th>Count</th>
					<th>Overview</th>
				</tr>
			</thead>
			<tbody>
				{recognition.map((r, index) => {
					const rowCount = recognition.length + 1
					return (
						<tr key={`recognition-${r.Level}`}>
							<td>{r.Level}</td>
							<td style={{ backgroundColor: r.Color, color: '#000' }}>{r.Count}</td>
							{index === 0 && (
								<td rowSpan={rowCount} style={{ verticalAlign: 'top' }}>
									<textarea
										rows={rowCount * 2}
										className="form-control"
										value={overview['recognition'] || ''}
										onChange={(e) => onOverviewChange('recognition', e.target.value)}
										style={{ height: '100%', resize: 'vertical' }}
									/>
								</td>
							)}
						</tr>
					)
				})}
				<tr>
					<td>
						<strong>TOTAL</strong>
					</td>
					<td>
						<strong>{recognition.reduce((sum, r) => sum + (r.Count || 0), 0)}</strong>
					</td>
				</tr>
			</tbody>
		</Table>
	</>
)

const ConsistencyTable = ({ consistency, overview, onOverviewChange }) => (
	<>
		<h5 className="mb-3">CONSISTENCY</h5>
		<Table bordered className="text-center">
			<colgroup>
				<col style={{ width: '30%' }} />
				<col style={{ width: '20%' }} />
				<col style={{ width: '50%' }} />
			</colgroup>
			<thead>
				<tr>
					<th>Duration</th>
					<th>Count</th>
					<th>Overview</th>
				</tr>
			</thead>
			<tbody>
				{consistency.map((c, index) => {
					const rowCount = consistency.length + 1
					return (
						<tr key={`consistency-${c.Grade}`}>
							<td>{c.Grade}</td>
							<td style={{ backgroundColor: c.Color, color: '#000' }}>{c.Count}</td>
							{index === 0 && (
								<td rowSpan={rowCount} style={{ verticalAlign: 'top' }}>
									<textarea
										rows={rowCount * 2}
										className="form-control"
										value={overview['consistency'] || ''}
										onChange={(e) => onOverviewChange('consistency', e.target.value)}
										style={{ height: '100%', resize: 'vertical' }}
									/>
								</td>
							)}
						</tr>
					)
				})}
				<tr>
					<td>
						<strong>TOTAL</strong>
					</td>
					<td>
						<strong>{consistency.reduce((sum, c) => sum + (c.Count || 0), 0)}</strong>
					</td>
				</tr>
			</tbody>
		</Table>
	</>
)

const ImpactTable = ({ impact, overview, onOverviewChange }) => (
	<>
		<h5 className="mb-3">IMPACT</h5>
		<Table bordered className="text-center">
			<colgroup>
				<col style={{ width: '30%' }} />
				<col style={{ width: '20%' }} />
				<col style={{ width: '50%' }} />
			</colgroup>
			<thead>
				<tr>
					<th>Position</th>
					<th>Count</th>
					<th>Overview</th>
				</tr>
			</thead>
			<tbody>
				{impact.map((i, index) => {
					const rowCount = impact.length + 1
					return (
						<tr key={`impact-${i.Position}`}>
							<td>{i.Position}</td>
							<td style={{ backgroundColor: i.Color, color: '#000' }}>{i.Count}</td>
							{index === 0 && (
								<td rowSpan={rowCount} style={{ verticalAlign: 'top' }}>
									<textarea
										rows={rowCount * 2}
										className="form-control"
										value={overview['impact'] || ''}
										onChange={(e) => onOverviewChange('impact', e.target.value)}
										style={{ height: '100%', resize: 'vertical' }}
									/>
								</td>
							)}
						</tr>
					)
				})}
				<tr>
					<td>
						<strong>TOTAL</strong>
					</td>
					<td>
						<strong>{impact.reduce((sum, i) => sum + (i.Count || 0), 0)}</strong>
					</td>
				</tr>
			</tbody>
		</Table>
	</>
)

const CommitmentTable = ({ commitment, overview, onOverviewChange }) => (
	<>
		<h5 className="mb-3">COMMITMENT</h5>
		<Table bordered className="text-center">
			<colgroup>
				<col style={{ width: '30%' }} />
				<col style={{ width: '20%' }} />
				<col style={{ width: '50%' }} />
			</colgroup>
			<thead>
				<tr>
					<th>Weeks/Year</th>
					<th>Count</th>
					<th>Overview</th>
				</tr>
			</thead>
			<tbody>
				{commitment.map((c, index) => {
					const rowCount = commitment.length + 1
					return (
						<tr key={`commitment-${c.Weeks}`}>
							<td>{c.Weeks}</td>
							<td style={{ backgroundColor: c.Color, color: '#000' }}>{c.Count}</td>
							{index === 0 && (
								<td rowSpan={rowCount} style={{ verticalAlign: 'top' }}>
									<textarea
										rows={rowCount * 2}
										className="form-control"
										value={overview['commitment'] || ''}
										onChange={(e) => onOverviewChange('commitment', e.target.value)}
										style={{ height: '100%', resize: 'vertical' }}
									/>
								</td>
							)}
						</tr>
					)
				})}
				<tr>
					<td>
						<strong>TOTAL</strong>
					</td>
					<td>
						<strong>{commitment.reduce((sum, c) => sum + (c.Count || 0), 0)}</strong>
					</td>
				</tr>
			</tbody>
		</Table>
	</>
)

const VarietyTable = ({ variety, overview, onOverviewChange }) => (
	<>
		<h5 className="mb-3">VARIETY</h5>
		<Table bordered className="text-center">
			<colgroup>
				<col style={{ width: '30%' }} />
				<col style={{ width: '20%' }} />
				<col style={{ width: '50%' }} />
			</colgroup>
			<thead>
				<tr>
					<th>Category</th>
					<th>Count</th>
					<th>Overview</th>
				</tr>
			</thead>
			<tbody>
				{variety.map((v, index) => {
					const rowCount = variety.length + 1
					return (
						<tr key={`variety-${v.Category}`}>
							<td>{v.Category}</td>
							<td style={{ backgroundColor: v.Color, color: '#000' }}>{v.Count}</td>
							{index === 0 && (
								<td rowSpan={rowCount} style={{ verticalAlign: 'top' }}>
									<textarea
										rows={rowCount * 2}
										className="form-control"
										value={overview['variety'] || ''}
										onChange={(e) => onOverviewChange('variety', e.target.value)}
										style={{ height: '100%', resize: 'vertical' }}
									/>
								</td>
							)}
						</tr>
					)
				})}
				<tr>
					<td>
						<strong>TOTAL</strong>
					</td>
					<td>
						<strong>{variety.reduce((sum, v) => sum + (v.Count || 0), 0)}</strong>
					</td>
				</tr>
			</tbody>
		</Table>
	</>
)

const StudentActivityReportList = ({ studentId, isStudentView = true }) => {
	const [recognition, setRecognition] = useState([])
	const [consistency, setConsistency] = useState([])
	const [impact, setImpact] = useState([])
	const [commitment, setCommitment] = useState([])
	const [variety, setVariety] = useState([])
	const [overview, setOverview] = useState({})
	const [loading, setLoading] = useState(true)
	const [toastMessage, setToastMessage] = useState('')
	const [showToast, setShowToast] = useState(false)
	const [updating, setUpdating] = useState(false)

	const colorMap = {
		blue: '#b3e5fc',
		green: '#c8e6c9',
		yellow: '#fff9c4',
		orange: '#ffe0b2',
		lightRed: '#ffcdd2',
		red: '#ef9a9a',
		default: '#f1f1f1'
	}

	const loadData = async () => {
		try {
			setLoading(true)

			const overviewRes = await getOverviewTexts(studentId)

			// Load Recognition
			const recognitionRes = await getActivityListLevelCount(studentId)
			const recognitionTypes = {
				International: colorMap.blue,
				National: colorMap.green,
				Regional: colorMap.yellow,
				State: colorMap.orange,
				City: colorMap.lightRed,
				School: colorMap.red
			}

			const recognitionData = recognitionRes.map((item) => ({
				Level: item.Level,
				Count: item.Count,
				Color: recognitionTypes[item.Level] || colorMap.default
			}))
			setRecognition(recognitionData)

			// Load Consistency
			const consistencyRes = await getActivityListGradeLevelCount(studentId)
			const consistencyTypes = {
				9: colorMap.red,
				10: colorMap.red,
				11: colorMap.red,
				12: colorMap.red,
				'9-12': colorMap.blue,
				'10-12': colorMap.green,
				'9-11': colorMap.yellow,
				'9-10': colorMap.orange,
				'10-11': colorMap.orange,
				'11-12': colorMap.lightRed
			}

			const consistencyData = consistencyRes.map((item) => ({
				Grade: item.Grade,
				Count: item.Count,
				Color: consistencyTypes[item.Grade] || colorMap.default
			}))
			setConsistency(consistencyData)

			// Load Impact
			const impactRes = await getActivityListPositionCount(studentId)
			const impactTypes = {
				Founder: colorMap.blue,
				President: colorMap.green,
				Officer: colorMap.yellow,
				Organizer: colorMap.orange,
				Helper: colorMap.lightRed,
				Member: colorMap.red
			}

			const positionCodes = {
				'1.FDR': 'Founder',
				'2.PRS': 'President',
				'3.OFC': 'Officer',
				'4.ORG': 'Organizer',
				'5.HLP': 'Helper',
				'6.MBR': 'Member'
			}

			const impactData = impactRes.map((item) => {
				const position = positionCodes[item.Position] || item.Position
				return {
					Position: position,
					Count: item.Count,
					Color: impactTypes[position] || colorMap.default
				}
			})
			setImpact(impactData)

			// Load Commitment
			const commitmentRes = await getActivityListWeeksPerYearCount(studentId)
			const commitmentTypes = {
				'40-50': colorMap.blue,
				'31-39': colorMap.green,
				'21-30': colorMap.yellow,
				'11-20': colorMap.orange,
				'6-10': colorMap.lightRed,
				'0-5': colorMap.red
			}

			const commitmentData = commitmentRes
				.map((item) => ({
					Weeks: item.range,
					Count: item.Count,
					Color: commitmentTypes[item.range] || colorMap.default
				}))
				.sort((a, b) => a.Weeks.localeCompare(b.Weeks))
			setCommitment(commitmentData)

			// Load Variety
			const varietyRes = await getActivityListCategoryCount(studentId)
			const categoryCodes = {
				'A/R/P': 'Academic/Research/Publication',
				Career: 'Career-Oriented',
				Intern: 'Internship',
				Service: 'Community Service',
				'Db/Gov': 'Debate/Speech/Student Govt',
				Sports: 'Athletics Team',
				Arts: 'Art/Music/Theater/Dance',
				Family: 'Family Responsibility',
				Work: 'Work',
				Clubs: 'Others/Clubs'
			}

			const varietyData = varietyRes.map((item) => {
				const category = categoryCodes[item.Category] || item.Category
				return {
					Category: category,
					Count: item.Count,
					Color: colorMap.default
				}
			})
			setVariety(varietyData)

			// Set overview data
			const overviewMap = {}
			overviewRes.forEach((item) => {
				overviewMap[item.type] = item.desc
			})
			setOverview(overviewMap)
		} catch (error) {
			console.error('Error loading activity reports:', error)
		} finally {
			setLoading(false)
		}
	}

	const showToastMessage = (message) => {
		setToastMessage(message)
		setShowToast(true)
		setTimeout(() => setShowToast(false), 3000)
	}

	const handleOverviewChange = (key, value) => {
		setOverview((prev) => ({ ...prev, [key]: value }))
	}

	const handleUpdate = async () => {
		setUpdating(true)
		try {
			await saveOverviewTexts(studentId, overview)
			showToastMessage('Activity reports updated successfully!')
			await loadData()
		} catch (error) {
			console.error('Error saving overview:', error)
		} finally {
			setUpdating(false)
		}
	}

	useEffect(() => {
		if (studentId) {
			loadData()
		}
	}, [studentId])

	return (
		<div className="p-3">
			<ToastNotification show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />

			{loading ? (
				<div className="text-center p-4">
					<div className="spinner-border" role="status">
						<span className="visually-hidden">Loading...</span>
					</div>
					<p className="mt-2">Loading activity reports...</p>
				</div>
			) : (
				<>
					<h4 className="mb-4">Activity Reports</h4>

					<RecognitionTable recognition={recognition} onOverviewChange={handleOverviewChange} overview={overview} />
					<ConsistencyTable consistency={consistency} onOverviewChange={handleOverviewChange} overview={overview} />
					<ImpactTable impact={impact} onOverviewChange={handleOverviewChange} overview={overview} />
					<CommitmentTable commitment={commitment} onOverviewChange={handleOverviewChange} overview={overview} />
					<VarietyTable variety={variety} onOverviewChange={handleOverviewChange} overview={overview} />

					<div className="text-end mt-3">
						<Button color="primary" onClick={handleUpdate} disabled={updating}>
							<i className="fa fa-save me-2"></i>
							{updating ? 'Updating...' : 'Update Reports'}
						</Button>
					</div>
				</>
			)}
		</div>
	)
}

export { StudentActivityReportList }
